var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$store.state.isAdmin)?_c('v-container',[_c('v-alert',{attrs:{"color":"red","dense":"","icon":"mdi-alert","text":"","type":"warning"}},[_vm._v(" You do not have access to this section. ")])],1):_c('AdminComponent')}
var staticRenderFns = []

export { render, staticRenderFns }